import BookingCTA from 'components/forms/bookingWidget/BookingCTA';
import { ButtonContainer } from './shared';

interface SubmitBookingWidgetProps {
  isProcessing: boolean;
  isDayAvailable: boolean;
  trackRequestToBookStart: () => void;
  boatId: string;
}
export default ({ isProcessing, isDayAvailable, trackRequestToBookStart, boatId }: SubmitBookingWidgetProps) => (
  <ButtonContainer data-testid="pdp-booking-widget-submit-container">
    <BookingCTA onClick={trackRequestToBookStart} loading={isProcessing} boatId={boatId} disabled={!isDayAvailable} />
  </ButtonContainer>
);
